import { SVGProps } from 'react';

const CircleArrowOutUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 2H2v6m0-6 10 10m0-10A10 10 0 1 1 2 12"
    />
  </svg>
);
export default CircleArrowOutUpLeft;
